


































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import HeaderHome from '../../components/headerhome.vue';
import FlightSearchInput from '@/store/entities/flight/flightSearchInput';
import SearchTransferInput from '@/store/entities/transfer/searchTransferInput';
import Airport from '@/store/entities/airport';
import moment from 'moment-timezone';
import FlightSearch from '@/store/entities/flight/flightSearch';
import ajax from '@/lib/ajax';
import FlightCampaign from '@/store/entities/flight/flightCampaign';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Ajax from '../../lib/ajax';
import TransferImageGallery from '../../components/transferImageGallery.vue';


@Component({
  components: { HeaderHome, VueTimepicker, TransferImageGallery },
})
export default class Home extends Vue {
  radios: string = 'radios1';
  startDate: string = null;
  transferDate: string = null;

  endDate: string = null;
  adultCount: number = 1;
  childCount: number = 0;
  infantCount: number = 0;
  flightSearchInput: FlightSearchInput = new FlightSearchInput();
  fromAirports: Airport[] = [];
  toAirports: Airport[] = [];
  flightSearch: FlightSearch = new FlightSearch();
  flightSearchArray: FlightSearchInput[] = [];
  startTimeMenu: boolean = false;
  endTimeMenu: boolean = false;
  trfDateMenu: boolean = false;
  nowDate: string = new Date().toISOString().slice(0, 10);
  endDatePicker: string = new Date().toISOString().slice(0, 10);
  disabled: boolean = true;
  getFromAirportsRequestObject: any = {};
  getToAirportsRequestObject: any = {};
  loadingFromAirport: boolean = false;
  loadingToAirport: boolean = false;
  searchFromInput: string = '';
  searchToInput: string = '';
  campaignFlights: FlightCampaign[] = [];
  isChange: boolean = false;
  allAirports: Airport[] = [];
  newPrice: string;
  oldPrice: string;
  backgroundImagePath:string;
  showPromoTrf: boolean = false;
  time: string = null;
  menu2: boolean = false;
  tabkey:any
  allRegions: any[] = [];
  fromRegion:any={};
  toRegion:any={};
  transferHour:any={}
  adultTransferCount: number = 1;
  childTransferCount: number = 0;
  infantTransferCount: number = 0;


    get getLanguage(){
   return this.$root.$i18n.locale;
  }

  get getTwoWay() {
    return this.radios && this.radios === 'radios2' ? false : true;
  }

  async created() {
    
    abp.utils.setCookieValue("marker","test");
    await this.getCampaignFlights();
    this.campaignFlights.map((item: any) => {
      this.priceFormatter(item.price, item.currencyId).then((res) => {
        item.price = res.total;
        item.currencyId = res.secondCurrencyId;
      });
    });
  }

  async priceFormatter(price, currencyId) {
    if (this.newPrice !== undefined && this.oldPrice === undefined) {
      const payload = {
        amount: price,
        firstCurrencyId: currencyId,
        secondCurrencyId: this.$store.state.currency.id,
      };
      const response = await ajax.post(
        '/api/services/app/Booking/ConvertExchangeRate',
        payload
      );
      return response.data.result;
    }

    const payload = {
      amount: price,
      firstCurrencyId: currencyId,
      secondCurrencyId: this.newPrice,
    };
    const response = await ajax.post(
      '/api/services/app/Booking/ConvertExchangeRate',
      payload
    );
    return response.data.result;
  }

  async changeFlightList() {
    await this.campaignFlights.map((item: any) => {
      this.priceFormatter(item.price, item.currencyId).then((res) => {
        item.price = res.total;
        item.currencyId = res.secondCurrencyId;
      });
    });
  }

  @Watch('currencyFormat', { immediate: true })
  onChangeCurrencyFormat(price, oldPrice) {
    this.newPrice = price;
    this.oldPrice = oldPrice;
    this.changeFlightList();
  }

  get currencyFormat() {
    return this.$store.state.currency.id;
  }

  set currencyFormat(value) {
    this.newPrice = value;
  }

  endDateEvents(event) {
    if (new Date(event) > new Date(this.startDate)) {
      return;
    } else if (new Date(event) <= new Date(this.startDate)) {
      alert('Dönüş Zamanı gidiş zamanından ileri tarih olmalıdır!');
      this.endDate = '';
    }
  }
  returnEvents(e) {
    this.radios == 'radios2';
    this.disabled = false;
  }

  async getFromAirportsForAutoComplete() {
    this.loadingFromAirport = true;
    await this.$store.dispatch({
      type: 'airport/getFromAirports',
      data: this.getFromAirportsRequestObject,
    });
    this.fromAirports = this.$store.state.airport.fromAirportlist;
    this.loadingFromAirport = false;
  }
  async getToAirportsForAutoComplete() {
    this.loadingToAirport = true;
    await this.$store.dispatch({
      type: 'airport/getToAirports',
      data: this.getToAirportsRequestObject,
    });
    this.toAirports = this.$store.state.airport.toAirportlist;
    this.loadingToAirport = false;
  }

  get getSearchFromInput() {
    return this.searchFromInput;
  }

  set getSearchFromInput(value: string) {
    if (value && value.length > 0 && value.length >= 3 && value.length < 4) {
      this.getFromAirportsRequestObject.name = value;
      this.getFromAirportsForAutoComplete();
    }
  }

  get getSearchToInput() {
    return this.searchToInput;
  }

  set getSearchToInput(value: string) {
    if (value && value.length > 0 && value.length >= 3 && value.length < 4) {
      this.getToAirportsRequestObject.name = value;
      this.getToAirportsForAutoComplete();
    }
  }

  async searchFlight() {
    this.flightSearchArray = [];
    this.flightSearchInput.clientDepartureDate = moment(this.startDate).format(
      'DD-MM-yyyy'
    );
    this.flightSearchInput.clientArrivalDate = this.endDate
      ? moment(this.endDate).format('DD-MM-yyyy')
      : '';
    this.flightSearchInput.departureDate = moment(this.startDate).format(
      'DD-MM-yyyy'
    );
    this.flightSearchInput.arrivalDate = this.endDate
      ? moment(this.endDate).format('DD-MM-yyyy')
      : '';
    this.flightSearchInput.adultCount = this.adultCount;
    this.flightSearchInput.childCount = this.childCount;
    this.flightSearchInput.infantCount = this.infantCount;
    this.flightSearchInput.flightType = this.flightSearchInput.arrivalDate
      ? 'RTF'
      : 'OWF';
    this.flightSearchInput.flightSearchType = this.flightSearchInput
      .clientArrivalDate
      ? 1
      : 0;
    this.flightSearchInput.refId = 189;
    this.flightSearchInput.currencyId = this.$store.state.currency.id;
    this.flightSearchArray.push(this.flightSearchInput);
    this.flightSearch.flightSearchInputs = this.flightSearchArray;
    this.flightSearch.saleChannelId = 'INTERNET';

    await this.$store
      .dispatch({
        type: 'flight/searchFlight',
        data: this.flightSearch,
      })
      .then((response) => {
        this.$router.push('/flightSearch/' + response);
      });
  }

  async campaignFlightSearch(flight) {
    let flightSearchArray = [];
    this.flightSearchInput.departureDate = moment(flight.departureDate).format(
      'DD-MM-yyyy'
    );
    this.flightSearchInput.clientDepartureDate = moment(
      flight.departureDate
    ).format('DD-MM-yyyy');
    this.flightSearchInput.adultCount = this.adultCount;
    this.flightSearchInput.childCount = this.childCount;
    this.flightSearchInput.infantCount = this.infantCount;
    this.flightSearchInput.currencyId = this.$store.state.currency.id;
    this.flightSearchInput.flightSearchType = flight.clientArrivalDate ? 1 : 0;
    this.flightSearchInput.flightType = flight.arrivalDate ? 'RTF' : 'OWF';
    this.flightSearchInput.fromAirportId = flight.fromAirportId;
    this.flightSearchInput.toAirportId = flight.toAirportId;
    this.flightSearchInput.refId = 189;
    flightSearchArray.push(this.flightSearchInput);
    this.flightSearch.flightSearchInputs = flightSearchArray;
    this.flightSearch.saleChannelId = 'INTERNET';

    await this.$store
      .dispatch({
        type: 'flight/searchFlight',
        data: this.flightSearch,
      })
      .then((response) => {
        this.$router.push('/flightSearch/' + response);
      });
  }

  async getCampaignFlights() {
    const response = await ajax.get(
      '/api/services/app/Content/GetCampaignFlights'
    );
    this.campaignFlights = response.data.result;
  }

  changeAirport() {
    let fromAirports = this.fromAirports;
    let toAirports = this.toAirports;
    this.toAirports = fromAirports;
    this.fromAirports = toAirports;
    let fromAirport = this.flightSearchInput.fromAirport;
    let toAirport = this.flightSearchInput.toAirport;
    this.flightSearchInput.fromAirport = toAirport;
    this.flightSearchInput.toAirport = fromAirport;
    let fromAirportInput = this.searchFromInput;
    let toAirportInput = this.searchToInput;
    this.searchToInput = fromAirportInput;
    this.searchFromInput = toAirportInput;
  }
  get getEndDate() {
    return this.endDate != null
      ? moment(this.endDate).format('DD-MM-yyyy')
      : '';
  }

  get getStartDate() {
    return this.startDate != null
      ? moment(this.startDate).format('DD-MM-yyyy')
      : '';
  }

  get getTransferDate() {
    return this.transferDate != null
      ? moment(this.transferDate).format('DD-MM-yyyy')
      : '';
  }

  get totalPassengerCount() {
    return this.adultCount + this.childCount + this.infantCount;
  }
  get totalTransferPassengerCount() {
    return this.adultTransferCount + this.childTransferCount + this.infantTransferCount;
  }

  plusAdultCount() {
    if (this.adultCount < 9) this.adultCount += 1;
  }

  minusAdultCount() {
    if (this.adultCount != 1) this.adultCount -= 1;
  }

  plusChildCount() {
    if (this.childCount < 9) this.childCount += 1;
  }
  minusChildCount() {
    if (this.childCount != 0) this.childCount -= 1;
  }
  plusInfantCount() {
    if (this.infantCount < 9) this.infantCount += 1;
  }
  minusInfantCount() {
    if (this.infantCount != 0) this.infantCount -= 1;
  }


  plusTransferAdultCount() {
    if (this.adultTransferCount < 9) this.adultTransferCount += 1;
  }

  minusTransferAdultCount() {
    if (this.adultTransferCount != 1) this.adultTransferCount -= 1;
  }

  plusTransferChildCount() {
    if (this.childTransferCount < 9) this.childTransferCount += 1;
  }
  minusTransferChildCount() {
    if (this.childTransferCount != 0) this.childTransferCount -= 1;
  }
  plusTransferInfantCount() {
    if (this.infantTransferCount < 9) this.infantTransferCount += 1;
  }
  minusTransferInfantCount() {
    if (this.infantTransferCount != 0) this.infantTransferCount -= 1;
  }


  @Watch('radios')
  onHandle(value, old) {
    if (value === 'radios1') {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

data() {
  return {
    backgroundImagePath: require('@/images/header_image.png'),
  };
}


handleChangeAndShowPromoTrf(tabKey) {

      if (tabKey === 'transfer') {
        this.backgroundImagePath = require('@/images/transfer_bg.jpg');
       this.showPromoTrf = true; 
        this.getRegions();

      } else {
        this.backgroundImagePath = require('@/images/header_image.png');
              this.showPromoTrf = false; 

      }
    }
  

searchTransfer(){

  let hour = this.transferHour["HH"]+":"+this.transferHour["mm"]

  debugger;
  console.log(this.transferHour["HH"])
  if(this.transferHour["HH"]=="" || this.transferHour["mm"]=="" || this.transferHour["HH"]==undefined ||this.transferHour["mm"]==undefined ){
    this.$swal({
                icon: 'error',
                title: 'Transfer Saati',
                text: 'Seçiniz',
                confirmButtonText: 'Tamam',
              })
              return;
  }
  if(Object.keys(this.fromRegion).length==0 || Object.keys(this.toRegion).length==0){
    this.$swal({
                icon: 'error',
                title: 'Kalkış-Varış Yeri',
                text: 'Seçiniz',
                confirmButtonText: 'Tamam',
              })
              return;
  }
  
  if(this.transferDate==null){
    this.$swal({
                icon: 'error',
                title: 'Kalkış Tarihi',
                text: ' Seçiniz',
                confirmButtonText: 'Tamam',
              })
              return;
  }

  var item = new SearchTransferInput();
  item.fromRegionId=this.fromRegion.id;
  item.toRegionId=this.toRegion.id;
  item.departureDate=this.transferDate;
  item.adultCount=this.adultTransferCount;
  item.childCount=this.childTransferCount;
  item.infantCount=this.infantTransferCount;
  item.currencyId=this.$store.state.currency.id;
  item.hour=hour;
  this.saveTransferSearch(item);

}
async getRegions(){
  const response = await Ajax.get(
        '/api/services/app/Transfer/GetRegions'
      );
  this.allRegions=response.data.result.items;


}

async saveTransferSearch(item){
  const response = await Ajax.post(
        '/api/services/app/Transfer/SaveTransferSearch',item
      );
  let id = response.data.result.id;
  let currencyId = this.$store.state.currency.id;
   this.$router.push('/transferSearch/'+id+'?currency='+currencyId)


}

}
